export const createCover = (
  index,
  doc,
  data,
  order,
  listBarcode,
  BreakException
) => {
  let allTest = [
    ...new Set(
      order.test_order
        .filter((test) => test.remark === "")
        .map((test) =>
          test.test_abbreviation ? test.test_abbreviation : test.test_name
        )
    ),
  ];
  let allSetTest = [
    ...new Set(
      order.test_order
        .filter((test) => test.remark !== "")
        .map((test) => test.remark)
    ),
  ];
  let allTitle = [...allTest, ...allSetTest];
  doc.setFontSize(7);
  doc.text(
    (data.species_name == "อื่นๆ" ? data.other_specie : data.species_name) +
      " " +
      data.name +
      "  AN : " +
      data.an,
    3,
    0.4,
    "center"
  );
  doc.setFontSize(6.5);
  let emergency = "";
  if (order.urgency_hospital_type == "ด่วน" || order.emergency_level == 1) {
    emergency = "Lab!ด่วน";
    doc.text(
      order.order_date + " LN:" + order.ln + " " + emergency,
      3,
      0.8,
      "center"
    );
  } else {
    doc.text(order.order_date + " LN:" + order.ln, 3, 0.8, "center");
  }
  if (order.hospital_id != null) {
    doc.text(
      order.hospital_id + " / " + order.direction_id,
      0.1,
      1.5,
      null,
      -90
    );
  }
  doc.setFontSize(9);
  let listTestType = [];
  let strTestType = "";
  order.test_order.forEach((element) => {
    if (element.barcode == listBarcode[index]) {
      if (!listTestType.includes(element.test_type_name)) {
        if (element.test_type_abbreviation != null) {
          listTestType.push(element.test_type_abbreviation);
        } else {
          listTestType.push(element.test_type_name);
        }
      }
    }
  });
  try {
    listTestType.forEach((element, index) => {
      if (strTestType.length >= 40) {
        strTestType = strTestType + "...";
        throw BreakException;
      } else {
        if (index == listTestType.length - 1) {
          strTestType = strTestType + element;
        } else {
          strTestType = strTestType + element + ", ";
        }
      }
    });
  } catch (e) {
    if (e !== BreakException) throw e;
  }
  let listTest = [];
  let strTest = "";
  order.test_order.forEach((element) => {
    if (element.barcode == listBarcode[index]) {
      if (!listTest.includes(element.test_name)) {
        if (element.test_abbreviation != null) {
          listTest.push(element.test_abbreviation);
        } else {
          listTest.push(element.test_name);
        }
      }
    }
  });
  try {
    listTest.forEach((element, index) => {
      if (index == listTest.length - 1) {
        strTest = strTest + element;
      } else {
        strTest = strTest + element + ", ";
      }
      // }
    });
  } catch (e) {
    if (e !== BreakException) throw e;
  }
  doc.setFontSize(30);
  doc.text(order.daily_number.toString(), 2.8, 2.2, null, null);
  doc.setLineWidth(0.1);
  if (order.emergency_level > 0) {
    doc.rect(1.5, 1.1, 3, 1.5);
  }
  doc.setFontSize(8);
  // let machineName = order.test_order
  //   .filter(x => x.barcode === listBarcode[index])
  //   .reduce((prev, curr) => [...prev, ...curr.machine_name], []);
  // // .map(x => x.machine_name);
  // //   console.log("machine", machineName);
  // machineName = machineName
  //   .filter((v, i) => machineName.indexOf(v) === i)
  //   .join(",");
  let width = 3;
  let str = allTitle.join(",");
  if (str.length > 40) {
    str = str.substring(1, 40) + "...";
  }
  // doc.text(`${allTitle}`, width, 3, null, null);
  doc.text(`${str}`, width, 3, "center");

  return doc;
};

export const createPage = (
  img,
  index,
  doc,
  data,
  order,
  listBarcode,
  width,
  height,
  BreakException
) => {
  doc.addPage([170.079, 99.2126], "l");
  doc.setFontSize(7);
  doc.text(
    (data.species_name == "อื่นๆ" ? data.other_specie : data.species_name) +
      " " +
      data.name +
      "  AN : " +
      data.an,
    3,
    0.4,
    "center"
  );
  doc.setFontSize(6.5);
  let emergency = "";
  if (order.urgency_hospital_type == "ด่วน" || order.emergency_level == 1) {
    emergency = "Lab!ด่วน";
    doc.text(
      order.order_date + " LN:" + order.ln + " " + emergency,
      3,
      0.8,
      "center"
    );
  } else {
    doc.text(order.order_date + " LN:" + order.ln, 3, 0.8, "center");
  }
  if (order.hospital_id != null) {
    doc.text(
      order.hospital_id + " / " + order.direction_id,
      0.1,
      1.5,
      null,
      -90
    );
  }
  doc.setFontSize(9);
  doc.text("[" + listBarcode[index] + "]", 0.4, 0.9, null, -90);
  doc.addImage(img.src, "JPEG", 1.5, 0.875, width, height);
  let listTestType = [];
  let strTestType = "";
  order.test_order.forEach((element) => {
    if (element.barcode == listBarcode[index]) {
      if (!listTestType.includes(element.test_type_name)) {
        if (element.test_type_abbreviation != null) {
          listTestType.push(element.test_type_abbreviation);
        } else {
          listTestType.push(element.test_type_name);
        }
      }
    }
  });
  try {
    listTestType.forEach((element, index) => {
      if (strTestType.length >= 40) {
        strTestType = strTestType + "...";
        throw BreakException;
      } else {
        if (index == listTestType.length - 1) {
          strTestType = strTestType + element;
        } else {
          strTestType = strTestType + element + ", ";
        }
      }
    });
  } catch (e) {
    if (e !== BreakException) throw e;
  }
  let listTest = [];
  let strTest = "";
  order.test_order.forEach((element) => {
    if (element.barcode == listBarcode[index]) {
      if (!listTest.includes(element.test_name)) {
        if (element.test_abbreviation != null) {
          listTest.push(element.test_abbreviation);
        } else {
          listTest.push(element.test_name);
        }
      }
    }
  });
  try {
    listTest.forEach((element, index) => {
      if (strTest.length >= 40) {
        strTest = strTest + "...";
        throw BreakException;
      } else {
        if (index == listTest.length - 1) {
          strTest = strTest + element;
        } else {
          strTest = strTest + element + ", ";
        }
      }
    });
  } catch (e) {
    if (e !== BreakException) throw e;
  }
  // other_specimen_type_name
  let specimen = order.test_order.find((x) => x.barcode === listBarcode[index]);
  let specimen_type_name = specimen.specimen_type_name;
  if (specimen_type_name === "Other") {
    specimen_type_name += ":" + specimen.other_specimen_type_name;
  }
  doc.setFontSize(6.5);
  doc.text(specimen_type_name, 3, 3, "center");
  // doc.text(strTestType, 3, 3, "center");
  doc.text(strTest, 3, 3.35, "center");
  //add daily_number
  doc.setFontSize(16);
  doc.text(order.daily_number.toString(), 5.4, 1.6, null, -90);
  doc.setLineWidth(0.05);
  if (order.emergency_level > 0) {
    doc.rect(5.3, 0.9, 0.6, 1.8);
  }
  doc.setFontSize(8);
  // let machineName = order.test_order
  //   .filter((x) => x.barcode === listBarcode[index])
  //   .reduce((prev, curr) => [...prev, ...curr.machine_name], []);
  // // .map(x => x.machine_name);
  // //   console.log("machine", machineName);
  // machineName = machineName
  //   .filter((v, i) => machineName.indexOf(v) === i)
  //   .join(",");
  // //   console.log(listBarcode[index], order.test_order);

  // doc.text(`${machineName}`, 5.1, 0.5, null, -90);

  return doc;
};
